<div class="mdc-layout-grid__inner">
	<div class="mdc-layout-grid__cell--span-12">
		<div class="ad">
			<div class="cover">
				<img *ngIf="locale.lang=='en'" [src]="enAboutusBanner | s3Image" />
				<img  *ngIf="locale.lang=='ku'" [src]="kuAboutusBanner | s3Image">
				<img *ngIf="locale.lang=='ar'" [src]="arAboutusBanner | s3Image">
			</div>
		</div>
	</div>

	<div class="mdc-layout-grid__cell--span-12">

		<h4 class="purple" id="n96">{{locale.translations['aboutus']['n394']}}</h4>

		<div class="mdc-layout-grid__cell--span-12 cs-mt-1">
			<mat-divider></mat-divider>
		</div>
	</div>
	<div class="mdc-layout-grid__cell--span-12">

		<ul class="list mdc-layout-grid__cell--span-12">
			<p>
				{{locale.translations['aboutus']['n395']}}
            </p>
			<p>
				{{locale.translations['aboutus']['n396']}}
			</p>

		</ul>
	</div>


	<div class="mdc-layout-grid__cell--span-12 ">

		<h4 class="purple cs-mt-1" id="n101">{{locale.translations['aboutus']['n397']}}</h4>
        <div class="mdc-layout-grid__cell--span-12 cs-mt-1">
			<mat-divider></mat-divider>
		</div>
		</div>
		<div class="mdc-layout-grid__cell--span-12">
		<div class="pay-btn-cont">

			<li id="n97"><span>{{locale.translations['aboutus']['n398']}}</span></li>
			<li id="n98"><span>{{locale.translations['aboutus']['n399']}}</span></li>
			<li id="n99"><span>{{locale.translations['aboutus']['n400']}}</span></li>
			<li id="n99"><span>{{locale.translations['aboutus']['n401']}}</span></li>

 		</div>
		 <p>
			{{locale.translations['aboutus']['n402']}}
 		 </p>
		 <p>{{locale.translations['aboutus']['n403']}}</p>

	</div>
</div>
